module.exports = __webpack_public_path__ + "media/images/unsplash_img_02-54c414c37c78a94b8374bf8457238730.jpeg";